import React from 'react'
import { Bar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import './ContentAnalyticsChart.scss'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
)

const ContentAnalyticsChart = ({ statistics }) => {
  if (!statistics) {
    return (
      <div className="content-analytics-chart">
        <div className="chart-header">
          <h3 className="chart-title">Content Analytics</h3>
          <p className="chart-subtitle">No data available</p>
        </div>
      </div>
    )
  }

  const data = {
    labels: ['Chapters', 'Question Banks', 'Files', 'Flashcard Sets'],
    datasets: [
      {
        label: 'Content Count',
        data: [
          statistics.totalChapters,
          statistics.totalQBanks,
          statistics.totalFiles,
          statistics.totalFlashcardSets
        ],
        backgroundColor: [
          '#3b82f6',
          '#10b981',
          '#f59e0b',
          '#8b5cf6'
        ],
        borderColor: [
          '#2563eb',
          '#059669',
          '#d97706',
          '#7c3aed'
        ],
        borderWidth: 2,
        borderRadius: 8,
        borderSkipped: false,
      }
    ]
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: true,
        text: 'Content Creation Analytics',
        font: {
          size: 16,
          weight: 'bold'
        },
        color: '#003e4b'
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: '#e5e7eb',
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: false,
        callbacks: {
          label: function(context) {
            return `${context.label}: ${context.parsed.y} items`
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: '#f1f5f9'
        },
        ticks: {
          color: '#6b7280',
          font: {
            weight: '500'
          }
        }
      },
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#6b7280',
          font: {
            weight: '600'
          }
        }
      }
    }
  }

  return (
    <div className="content-analytics-chart">
      <div className="chart-container">
        <Bar data={data} options={options} />
      </div>
      <div className="chart-summary">
        <div className="summary-grid">
          <div className="summary-item">
            <div className="summary-icon chapters">📄</div>
            <div className="summary-content">
              <div className="summary-value">{statistics.totalChapters}</div>
              <div className="summary-label">Chapters</div>
            </div>
          </div>
          <div className="summary-item">
            <div className="summary-icon qbanks">❓</div>
            <div className="summary-content">
              <div className="summary-value">{statistics.totalQBanks}</div>
              <div className="summary-label">Question Banks</div>
            </div>
          </div>
          <div className="summary-item">
            <div className="summary-icon files">📁</div>
            <div className="summary-content">
              <div className="summary-value">{statistics.totalFiles}</div>
              <div className="summary-label">Files</div>
            </div>
          </div>
          <div className="summary-item">
            <div className="summary-icon flashcards">🎴</div>
            <div className="summary-content">
              <div className="summary-value">{statistics.totalFlashcardSets}</div>
              <div className="summary-label">Flashcard Sets</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentAnalyticsChart
